<template>
  <div>
    <el-dialog title="发放积分" :visible.sync="updateOrderIntegralDialog" @close="addDialogClosed" width="30%">
      <el-form label-width="100px" :model="integralForm" :rules="rules" ref="addFormRef">
        <el-form-item label="积分" prop="integral">
          <el-input v-model="integralForm.integral" />
        </el-form-item>

        <el-form-item label="状态" prop="enumType">
          <el-select v-model="integralForm.enumType" clearable placeholder="请选择积分状态" style="width: 100%">
            <el-option key="INCOME" label="新增" value="INCOME"></el-option>
            <el-option key="EXPEND" label="扣除" value="EXPEND"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发放说明" prop="brief">
          <el-input v-model="integralForm.brief" type="textarea" maxlength="20" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateOrderIntegralDialog = false">取 消</el-button>
        <el-button @click="confirmIntegral">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { addIntegrals, getIntegralsByOrderId } from '@/api/Integral/Integral'
import { getData } from '@/utils/code'
import { integralRules } from '@/js/rules'

export default {
  name: "orderIntegral",
  data() {
    return {
      integralForm: {
        integral: 0,
        brief: '',
        enumType: '',
      },
      rules: integralRules,
      updateOrderIntegralDialog: false,
      integralData: ''
    }
  },
  methods: {
    //打开积分对话框
    editDialog(row, val) {
      this.integralData = JSON.parse(JSON.stringify(row))
      if (val === 'YES') {
        getIntegralsByOrderId(this.integralData.orderId).then((r) => {
          let data = getData(r)
          if (data != null) {
            this.integralForm.integral = data
            this.updateOrderIntegralDialog = true
          }
        })
      }else {
        this.updateOrderIntegralDialog = true
      }


    },

    //关闭对话框
    addDialogClosed() {
      this.integralForm = {}
    },

    //确定积分
    confirmIntegral() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        let data = {
          brief: this.integralForm.brief,
          enumType: this.integralForm.enumType,
          integral: Number(this.integralForm.integral),
          userId: this.integralData.userId,
          orderId: this.integralData.orderId
        }
        addIntegrals(data).then((r) => {
          let data = getData(r)
          if (data != null) {
            this.$message.success('发放积分成功!')
            this.integralForm.integral = 0
            this.integralForm.brief = ''
            this.updateOrderIntegralDialog = false
            this.$emit('refresh-list')
          }
        })
      })

    }
  }
}
</script>

<style scoped>

</style>
